/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'
import { range, createButtonAttributes } from '~cartzillagb/util'
import {
    disabledBlocks, i18n 
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import deprecated from './deprecated'


/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'

export const schema = {
    blockId: {
        type: 'string',
        default: '',
    },

    limit: {
        type: 'number',
        default: 1,
    },

    enableButton: {
        type: 'boolean',
        default: true,
    },
    autoplay: {
        type: 'boolean',
        default: false,
    },
    speed: {
        type: 'number',
        default: 1000,
    },
    autoplaySpeed: {
        type: 'number',
        default: 1000,
    },

    

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit = applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit + 1 ).map( i => {
    schema[ `title${ i }` ] = {
        type: 'string',
    }
    schema[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema[ `buttontitle${ i }` ] = {
        type: 'string',
    }
    schema[ `backgroundImage${ i }` ] = {
        type: 'string',
    }
    schema[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema[ `mediaURL${ i }` ] = {
        type: 'string',
    }
    schema[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema[ `enablebuttonTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
     schema[ `enableButton${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema[ `titleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema[ `titleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema[ `subtitleAnimation${ i }` ] = {
        type: 'string',
        default: 'from-bottom'
    }
    schema[ `subtitleDelay${ i }` ] = {
        type: 'string',
        default: 'delay-2'
    }
    schema[ `buttontitleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema[ `buttontitleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema[ `btnlimit${ i }` ] = {
        type: 'number',
        default: 2,
    }

    const Maxbtnlimit = applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 )

    { range( 1, Maxbtnlimit + 1 ).map( j => {
        schema[ `btnpretitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema[ `btntitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema[ `btnbgcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema[ `btnbgcustomcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema[ `btnicon${ i }${ j }` ] = {
            type: 'string',
        }
        schema[ `btnlink${ i }${ j }` ] = {
            type: 'string',
        }
        return ''
    } ) }

    schema[ `btnpretitle${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }

export const name = 'czgb/hero-carousel-3'

export const settings = {
    title: __( 'Hero Carousel #3', i18n ),
    description: __( 'Start building your website with Hero carousel #3.', i18n ),
    icon: HeaderIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Hero Carousel', i18n ),
        __( 'CartzillaGb', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    deprecated,
    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
        'custom-css': {
            default: applyFilters( 'cartzillagb.hero-carousel-3.custom-css.default', '' ),
        },
    },
}